<template>
    <div>
    <v-dialog v-model="dialog" width="1200px">
        <v-card>
            <v-form ref="downloadAllHsftZip">
            <v-card-title class="justify-center">download all photos as zip</v-card-title>
            <v-divider/>
            <div class="scrollable">
                <v-row no-gutters>
                    <v-col v-if="loading" cols="12" class="pa-4">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                        <v-col
                            class="text-center pa-2"    
                            cols="12"
                        >
                        <h3>Getting your files and preparing download...</h3>
                        </v-col>
                        <v-col cols="6">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="12"
                        ></v-progress-linear>
                        </v-col>
                    </v-row>
                    </v-col>
                    <v-col v-if="!loading" class="pa-2" cols="12">
                        <v-row class="fill-height" align-content="center" justify="center">
                            <v-col class="text-center pa-2 mt-7" cols="3">
                                <h3>Your ZIP file is ready!</h3>
                            </v-col>
                            <v-col class="text-center pa-2 mt-4" cols="3">
                                <v-btn
                            :loading="loading"
                            :disabled="loading"
                            color="primary"
                            class="ma-2 white--text"
                            :href="download_zip_url"
                            target="_blank"
                        >
                        Download ZIP
                        <v-icon
                            right
                            dark
                        >
                        mdi-cloud-download
                        </v-icon>
                        </v-btn>                        
                            </v-col>
                        </v-row>
                        
                        
                    </v-col>
                </v-row>
            </div>
            
                
            </v-form>
            <v-card-actions>
                <v-btn color="primary" small @click="closeDownloadAllHsftZip()">Close</v-btn> 
            </v-card-actions>
        
        </v-card>
    </v-dialog>
    </div>
</template>

<script>

    export default {
            components: {
        },
        data() { 
            return {
                huis_encrid: null,
                dialog: false,
                dialogbigdel: false,
                bigimage: null,
                reviveHsftValid: false,
                confirmTimer: null,
                confirmCounter: 0,
                fttg_nrKeuzes: [],
                hsft: {},
                hsft_array: [],
                huisprocessing: { hsft: []},
                selected: [],
                message: "",
                delCounter: 0,
                selected_checks: [
                    v => (v || '').length > 0 || 'Choose at least 1 photo to revive',
                ],
                items: [],
                isLoading: false,
                loading: false,
                model: null,
                search: null,
                download_zip_url : "",
            }
        },
        computed: {
            reactivePhotoArray: function () {
                return this.hsft_array.filter(() => {
                    return true;
                });
            }
        },
        methods: {
            open(huis_encrid) {
            this.huis_encrid = huis_encrid;
            this.$emit("showSnackbar");
            this.dialog = true;
            this.loading = true;
            this.$axios
                .post("ares/json/ares/huis/hsft/getAllHsftZip.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getAllHsftZip"
                },
                getAllHsftZip: {
                    huis_encrid: huis_encrid
                }
                })
                .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.download_zip_url = res.data.getAllHsftZip.download_zip_url;
                }
                })
                .finally(() => {
                    this.selected = [];
                    this.loading = false;
                });
            },
            closeDownloadAllHsftZip() {
                this.dialog = false;
            },
            
        }
    }
</script>

<style scoped>
    .flex{
        display: flex;
        flex-direction: row;
    }
    .scrollable {
        max-height: 600px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
